import React from 'react';
import { FaUpload } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { useNavigateToGivenPath } from '../../paymentSummary/service';
import { openFileInNewWindow } from '../../../../academicPlanAndTest/academicTimetable/lectureModule/LectureListItem';
import { detailsRowStyles } from '../../../constant/student-details';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';

const ConcessionForm = ({
    activeApplicationDetails
}) => {

    const navigateToGivenPath = useNavigateToGivenPath();

    const { parentConsentDetails = {}, applicationId } = activeApplicationDetails ?? {};

    const { digitalConsentS3Path, manualConsentS3Path, digitalConsentReceivedDate, manualConsentReceivedDate } = parentConsentDetails;
    const consentDocS3Key = digitalConsentS3Path || manualConsentS3Path || null;
    const updatedOn = digitalConsentReceivedDate || manualConsentReceivedDate || null;

    return (
        <div style={detailsRowStyles}>
            <div className='d-flex justify-content-between'>

                <div>Concession Form</div>


                {consentDocS3Key
                    ?
                    <span style={{ cursor: "pointer" }}>
                        <FaRegEye
                            onClick={() => openFileInNewWindow(consentDocS3Key)}
                            size={18}
                            color="00b0f5"
                        />
                    </span>
                    :
                    <div className="cursor" onClick={() => navigateToGivenPath(`/admin/studentCharges/details/${applicationId}/edit`)}>
                        <FaUpload
                            size={18}
                            color='00b0f5'
                        />
                    </div>
                }
            </div>
            {consentDocS3Key && <div className='uploaded-on-info'>Uploaded on : {getFormatedDate(updatedOn, true, 'DD/MM/YYYY')}</div>}
        </div>
    );
}

export default ConcessionForm;